export const environment = {
  production: false,
  apiUrl: 'https://webhooks.mongodb-stitch.com/api/client/v2.0/app/kegomate-test-fnmug/service/Kegomate/incoming_webhook',
  apiSecret: 'c0ffeeN0T5hour'
};
